import { ORDER_TERMS, SITE } from "@/config/site";

// Factual, consistent answers. Answers relying on unconfirmed terms are worded conditionally.
export const FAQS = {
  offer: {
    q: "What does KhozaLand offer?",
    a: "KhozaLand provides custom printing, branding, personalised apparel, promotional products, corporate gifts and Xhosa cultural products such as personalised Ingcawe/Ngcawe blankets and Ibhayi lombhaco.",
  },
  tshirtsCapeTown: {
    q: "Where can I get T-shirts printed in Cape Town?",
    a: `KhozaLand is a printing and branding business based in ${SITE.locationLabel}. We print custom T-shirts, golf shirts and branded clothing for individuals, families, businesses and groups. Request a quote online or WhatsApp ${SITE.phoneDisplay}.`,
  },
  uniformsMitchellsPlain: {
    q: "Who offers branded uniforms in Mitchells Plain?",
    a: "KhozaLand, based in Mitchells Plain, takes enquiries for branded uniforms and embroidered clothing for businesses, schools, churches and community groups. Share your logo, garment type and quantity for a quotation.",
  },
  corporateGifts: {
    q: "Where can I order personalised corporate gifts in Cape Town?",
    a: "KhozaLand personalises corporate gifts such as branded mugs, tumblers, candles, water bottles and apparel with your company name, logo or message. Request a corporate gift quote with your product, quantity and branding requirements.",
  },
  ingcawe: {
    q: "Who makes custom Ingcawe blankets?",
    a: "KhozaLand personalises Ingcawe/Ngcawe blankets with clan names, clan praises (iziduko), wording and chosen motifs. Ingcawe blankets start from R1 000 on our current price list — your final price is confirmed in your quotation.",
  },
  lombhaco: {
    q: "Where can I buy Ibhayi lombhaco?",
    a: "You can enquire about Ibhayi lombhaco from KhozaLand. Tell us your preferred design, colours, personalisation and quantity and we will confirm availability and pricing.",
  },
  churchSociety: {
    q: "Can I order customised clothing for a church or burial society?",
    a: "Yes. KhozaLand accepts group orders for churches, burial societies, schools and community organisations — including matching T-shirts, golf shirts, uniforms and personalised items.",
  },
  bulk: {
    q: "Do you accept bulk orders?",
    a: `Yes. Bulk orders are accepted. ${ORDER_TERMS.bulkDiscount.text}`,
  },
  quote: {
    q: "How do I request a quotation?",
    a: `Complete the quotation form on our Contact page or WhatsApp ${SITE.phoneDisplay}. Include the product, quantity, sizes, colours, your design or logo and your required date. KhozaLand will reply with a quotation — orders are only confirmed once you approve the quote.`,
  },
  ownLogo: {
    q: "Can I use my own logo or design?",
    a: "Yes. You can submit your own logos, names, photos or preferred designs with your enquiry. You can upload a reference file on the quotation form or send it via WhatsApp.",
  },
  ownDesign: {
    q: "Do you help with designs?",
    a: "Selected logo design and layout services are available on request. Share your idea and we will advise what is possible in your quotation.",
  },
  delivery: {
    q: "Does KhozaLand deliver outside Cape Town?",
    a: `KhozaLand is based in Cape Town and also accepts suitable orders from elsewhere in South Africa. ${ORDER_TERMS.delivery.text}`,
  },
  culturalProducts: {
    q: "Do you sell Xhosa cultural products?",
    a: "Yes. KhozaLand offers Xhosa cultural products including personalised Ingcawe/Ngcawe blankets and Ibhayi lombhaco, as well as clothing printed with clan names.",
  },
  production: {
    q: "How long does production take?",
    a: "Production time depends on the product, quantity and design. As a guide, many orders are normally completed in about 3–5 working days — your confirmed timeline is stated in your quotation.",
  },
  urgent: {
    q: "Do you offer urgent orders?",
    a: "No. KhozaLand does not accept urgent orders, so please plan ahead and include your required date when you request a quote.",
  },
  deposit: {
    q: "Is a deposit required?",
    a: "Deposit requirements are confirmed when your quotation is issued.",
  },
  prices: {
    q: "How much does custom printing cost?",
    a: "Prices depend on the product, quantity and design. As a guide, our current price list starts from R250 for a round-neck T-shirt, R300 for a golf shirt, R120 for a mug and R1 000 for an Ingcawe blanket, branded in your choice of style. Your final price is confirmed in your quotation.",
  },
  minimum: {
    q: "Is there a minimum order quantity?",
    a: "No minimum quantity has been published. Individual items and bulk orders are both welcome — tell us your quantity and we will confirm in your quotation.",
  },
};

export const FAQ_GROUPS = [
  { title: "About KhozaLand", keys: ["offer", "tshirtsCapeTown", "uniformsMitchellsPlain", "corporateGifts"] },
  { title: "Quotes & designs", keys: ["quote", "ownLogo", "ownDesign", "prices", "minimum"] },
  { title: "Bulk & group orders", keys: ["bulk", "churchSociety"] },
  { title: "Xhosa cultural products", keys: ["culturalProducts", "ingcawe", "lombhaco"] },
  { title: "Production, deposits & delivery", keys: ["production", "urgent", "deposit", "delivery"] },
];

export const faqList = (keys) => keys.map((k) => ({ id: k, ...FAQS[k] }));
